import * as React from 'react';

import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { Responsive } from '@cian/ui-kit/responsive';

import { AnalyticsUsefulFor } from '../../components/AnalyticsUsefulFor';
import { ProductYourNeeds } from '../../components/ProductYourNeeds';
import { Models } from '../../components/Models';
import { BigResource } from '../../components/BigResource';

import { trackViewBlock, EBlockName } from './tracking';

import { HeroContainer } from '../HeroContainer';
import { StickHeaderContainer } from '../StickHeaderContainer';
import { StickBottomContainer } from '../StickBottomContainer';
import { FeedbackContainer } from '../FeedbackContainer';
import { PublicationsContainer } from '../PublicationsContainer';
import { GraphsContainer } from '../Graphs';
import { BIReportsInfoContainer } from '../BIReportsInfoContainer';
import { ACTION_AFTER_VIEWED_TIMEOUT } from '../../constants/actionAfterViewed';

export function RootContainer() {
  return (
    <>
      <HeroContainer />
      <GraphsContainer />
      <ActionAfterViewed
        timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}
        callback={() => trackViewBlock(EBlockName.Useful)}
      >
        <AnalyticsUsefulFor />
      </ActionAfterViewed>
      <ActionAfterViewed
        timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}
        callback={() => trackViewBlock(EBlockName.PickUpProduct)}
      >
        <ProductYourNeeds />
      </ActionAfterViewed>
      <ActionAfterViewed
        timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}
        callback={() => trackViewBlock(EBlockName.Models)}
      >
        <Models />
      </ActionAfterViewed>
      <BIReportsInfoContainer />
      <BigResource />
      <ActionAfterViewed
        timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}
        callback={() => trackViewBlock(EBlockName.Publications)}
      >
        <PublicationsContainer />
      </ActionAfterViewed>
      <ActionAfterViewed timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT} callback={() => trackViewBlock(EBlockName.Form)}>
        <FeedbackContainer />
      </ActionAfterViewed>

      <Responsive desktop>
        <StickHeaderContainer />
      </Responsive>

      <Responsive tablet phone>
        <StickBottomContainer />
      </Responsive>
    </>
  );
}
